// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3Pr4l","overflowing":"ReadFullNote_overflowing__1UMrv"};